<kendo-window *ngIf="opened" class="connectedStatesCss" (close)="close()">
  <kendo-window-titlebar>
    <i class="ic_export_connected_states_white ic_export_connected_states_banner"></i>
    <span class="k-window-title">{{ title }}</span>
    <button class="k-button k-bare k-button-icon" kendoWindowMaximizeAction></button>
    <button class="k-button k-bare k-button-icon" kendoWindowRestoreAction></button>
    <button class="k-button k-bare k-button-icon" kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <div class="container">
    <div class="datas-container">
      <label class="lblTopbanner">{{toBannerHelperText}}</label>

      <kendo-grid 
      [data]="GridConnectedStates" 
      width="95%" 
      *ngIf="GridConnectedStates !== null"
        [scrollable]="'scroll'" 
        class="gridDataCss" 
        [sortable]="{ mode: 'multiple' }"
         [sort]="state.sort"
         (dataStateChange)="dataStateChange($event)"
         #gridStates>
        <ng-template kendoGridNoRecordsTemplate>
          {{EmptyRecordText}}
        </ng-template>


        <kendo-grid-column field="FileName" title="Fichier" [width]="350" [sortable]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.FileName}}
            <i *ngIf="dataItem.FileName" class="ic-download ic-grid-download-file"
              [ngClass]="{ 'ic-grid-download-file-disabled': !dataItem.FileAvailable }"
              [title]="dataItem.FileDownloadTooltip" (click)="DownloadZipFileClick(dataItem)"></i>
          </ng-template>

        </kendo-grid-column>
        <kendo-grid-column field="StatutText" title="Statut" [width]="140" [sortable]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.StatutText}}
            <i *ngIf="dataItem.StatusIconCss" class="ic-status {{ dataItem.StatusIconCss }}"
              [title]="dataItem.StatutIconTooltip"></i>
          </ng-template>

        </kendo-grid-column>
        <kendo-grid-column field="DeviceName" title="Console" [width]="150" [sortable]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            <label style="cursor: help;" [title]="dataItem.DeviceTooltip"
             [ngClass]="{ 'device-missing-css': dataItem.DeviceMissing }"
            >{{dataItem.DeviceName}}</label>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="DeviceAccount" title="Compte" [width]="150" [sortable]="true"></kendo-grid-column>

        <kendo-grid-column field="DateStart" title="Début" [width]="60" [sortable]="true"></kendo-grid-column>
        <kendo-grid-column field="DateEnd" title="Fin" [width]="60" [sortable]="true"></kendo-grid-column>


      </kendo-grid>
      <div *ngIf="IsLoadingInProgress">
        {{LoadingPrecoInProgressTxt}}
      </div>
      <div *ngIf="bannerInfostext" class="bannerInfosCss">
        {{bannerInfostext}}
      </div>
    </div>
    <div class="dvBottomButtons">
      <div class="dvRightButtons">
        <button class="k-button btn bottomButton" (click)="onClose()">Fermer</button>
        <button class="k-button k-primary btn btn-primary bottomButton" [disabled]="EnabledBtnUpdate==false"
          (click)="onReCheckStatusClick()" title="Vérifier le statut des envois">
          <ng-container *ngIf="!isLoadingStatus; else loadingTpl">
            Mise à jour
          </ng-container>

          <ng-template #loadingTpl>
            <span class="spinnerLoader" title="Vérification du statut des envois"></span>
            Mise à jour...
          </ng-template>

        </button>

      </div>
    </div>
  </div>
</kendo-window>